<rask-page
    pageTitle="Sök importerat kontrakt"
    noPadding
    [footerShow]="true">
    <ng-container headerContent>
        <rask-extern-virkeskop-search-panel></rask-extern-virkeskop-search-panel>
        <rask-extern-virkeskop-search-result></rask-extern-virkeskop-search-result>
    </ng-container>
    <ng-container footerContent>
        <rask-button [disabled]="!hasSelectedWithDokument()" (click)="import()">Kör om import</rask-button>
        <rask-button [disabled]="!hasSelectedWithDokument()" (click)="download()">Ladda ner dokument</rask-button>
    </ng-container>
</rask-page>

